import { Component, Input, OnInit } from '@angular/core';

declare const audiojs: any;

@Component({
  selector: 'app-audio-preview-wrapper',
  templateUrl: './audio-preview-wrapper.component.html',
  styleUrls: ['./audio-preview-wrapper.component.scss']
})
export class AudioPreviewWrapperComponent implements OnInit{

  @Input() public url;
  @Input() public thumbnail;
  @Input() public isAdvertisement;
  @Input() public materialAd;
  @Input() public content;
  @Input() public preview;
  @Input() public localPreview;
  @Input() public localPreviewType;

  showAudio: boolean = false;
  // public streamUrl: String = 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3';
  
  constructor() {
    
    // this.isAdvertisement = true;
    // this.url = false;

  }

  ngOnInit() {
      this.showAudio = !this.isAdvertisement
      // console.log(this.showAudio);
      
  }

  change(value){
    // this.materialAd.lable = "nil";
    this.showAudio = value;
  }

  
}
